import { Link } from "react-router";
import React, { Component } from "react";
import Barcode from 'react-barcode';
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { logout, getStorage } from "./CustomComponent.js"
import { Modal } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/index.css";
import "../assets/css/sidebar.css";
import "./global.js";

export default class BarcodeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_code: props.show_code || false,
      show_name: props.show_name || false,
      show_price: props.show_price || false,
      show_lot: props.show_lot || false,
      paper_size: props.paper_size || false,
      code: props.show_code || 'Example Code',
      name: props.show_name || 'Example Name',
      price: props.show_price || '100.00',
      lot: props.show_lot || 'Example lot',
    };
  }
  componentDidMount() { 
    console.log("show_code : ",this.props.show_code)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.show_name !== this.props.show_name) {
      this.setState({ show_name: this.props.show_name });
    }
  }
  icon = (icon) => { return (<label className="icon">{icon}</label>) }
  active = (path) => { return window.location.pathname.includes(path) }
  render() {
    return (
      <div className="justify-content-center">
      {
      this.props.show_name ? <h2 className="text-barcode mb-0" style={{ margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{this.props.name || 'Example Name'}</h2> : ''
      }
      <Barcode width={1.5} height={30} style={{ width: '5px', height: '5px' }} value={this.props.value || 'Example Value'} displayValue={false} />
      <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "5px"
      }} >
        {
        this.props.show_code ? <h2 className="text-barcode" style={{ margin: 0, fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{this.props.code || 'Example Code'}</h2> : ''
        }
        {
        this.props.show_price ? <h2 className="text-barcode mb-0" style={{ margin: 0, fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>฿{this.props.price || '100.00'}</h2> : ''
        }
      </div>
      {
      this.props.show_lot ? <h2 className="text-barcode mb-0" style={{ margin: 0, fontSize: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{this.props.lot || 'Example lot'}</h2> : ''
      }
      </div>
    );
  }
} 